"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Slider_1 = require("../../components/Slider");
const Spacing_styles_1 = require("./Spacing.styles");
function Spacing({ onUpdate, options }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const theme = (0, ui_common_components_1.useTheme)();
    const handleValues = (0, react_1.useCallback)((data, action) => {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({ action: action, data: data });
    }, [onUpdate]);
    return ((0, jsx_runtime_1.jsx)(Spacing_styles_1.StyledSpacingContainer, { children: options.map((option, index) => {
            var _a, _b, _c;
            if (option.type === 'title') {
                return ((0, jsx_runtime_1.jsxs)(Spacing_styles_1.StyledTitle, { children: [option.icon && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: option.icon, color: theme.Color.Neutrals.Dark })), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "SmallHeavy", children: t(option.titleKey) })] }, `${index + option.titleKey}`));
            }
            if (option.type === 'divider') {
                return (0, jsx_runtime_1.jsx)(Spacing_styles_1.StyledDivider, {});
            }
            return ((0, jsx_runtime_1.jsxs)(Spacing_styles_1.StyledOptionsContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: t(option.titleKey) }), (0, jsx_runtime_1.jsx)(Slider_1.Slider, { id: `spacing-margin-${index + option.titleKey}`, maxValue: (_a = option.max) !== null && _a !== void 0 ? _a : 100, minValue: (_b = option.min) !== null && _b !== void 0 ? _b : 0, value: (_c = option.value) !== null && _c !== void 0 ? _c : option.min, variant: "section", onUpdate: (optionsValues) => { var _a; return handleValues(optionsValues, (_a = option.action) !== null && _a !== void 0 ? _a : ''); } })] }, option.titleKey));
        }) }));
}
exports.Spacing = Spacing;
//# sourceMappingURL=Spacing.js.map